import { ImgHTMLAttributes, memo } from 'react'
import cn from 'classnames'
import './image.style.scss'

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Sets the object fit of component
   */
  fit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'
  /**
   * Sets the loading of component
   */
  loading?: 'lazy' | 'eager'
}

const ImageComponent = (props: ImageProps) => {
  const { className, fit = 'fill', loading = 'lazy', ...rest } = props

  const classWrapper = cn(className, {
    'legion-image': true,
    [`legion-image--${fit}`]: true,
  })

  return (
    <img {...rest} className={classWrapper} loading={loading}/>
  )
}

export const Image = memo(ImageComponent)
